// Values must match the backend enums (CreditCardRecModels.cs), which are serialised as numbers.
export enum CreditCardType {
  Visa = 0,
  MasterCard = 1
}

export enum DirectFeedFolder {
  Ingestions = 0,
  Errors = 1
}

export interface FilenameWhitelist {
  id: string;
  creditCardType: CreditCardType;
  filenamePrefix: string;
  filenameSuffix?: string;
}

export interface DirectFeedConfig {
  id: string;
  creditCardType: CreditCardType;
  filenameWhitelist: FilenameWhitelist[];
  isProcessingEnabled: boolean;
}

export interface FeedAccount {
  last4Digits: string;
  isMasked: boolean;
  accountName: string;
  companyName: string;
}

export interface FeedFilePending {
  path: string;
  name: string;
  createdAt?: string;
  canBeDecrypted?: boolean;
  decryptionErrorReason?: string;
  extractErrorMessage?: string;
  fileType: string;
  fileContentVersion?: string;
  textFileContent?: string;
  accountsFound: FeedAccount[];
  isTestFile: boolean;
  allCompanyNames?: string[];
  isAccountInformationMissing: boolean;
  hasCardDetails: boolean;
}

export interface FeedFileArchived {
  path: string;
  name: string;
  createdAt?: string;
  fileType: string;
}

export interface ToggleProcessingRequest {
  clientId?: number;
  creditCardType?: CreditCardType;
  isProcessingEnabled?: boolean;
  prefixWhitelist: string[];
}

export interface ValidateFileRequest {
  clientId: number;
  creditCardType: CreditCardType;
  filename: string;
}

export interface GetDirectFeedConfigsResponse {
  configs: DirectFeedConfig[];
}

export interface GetDirectFeedFeedFilesResponse {
  containerExists: boolean;
  unprocessedFiles: FeedFilePending[];
  erroredFiles: FeedFilePending[];
  processedFiles: FeedFileArchived[];
  filenamePrefixSuggestion: string;
}

export interface ValidateVisaFirstFileResponse {
  isValidFirstFile: boolean;
  message: string;
  missingDataWarnings: string[];
}
